import { createStore } from "redux";

const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  exportJobId: localStorage.getItem("exportJobId") || null,
};

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case "set":
      console.log(rest);
      return { ...state, ...rest };
    default:
      return state;
  }
};

const store = createStore(changeState);
export default store;
